module.exports = __webpack_public_path__ + "static/media/lot_head1.f89e8cd4.svg";